/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Other Querying Features";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p>{"Observability Platform also provides querying features beyond those covered by using\nquery languages in its user interface."}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li><_components.strong><_components.a href="/investigate/querying/delta-queries">{"Delta queries"}</_components.a>{":"}</_components.strong>{" Query metrics that employ\ndelta temporality, as opposed to cumulative temporality."}</_components.li>{"\n"}<_components.li><_components.strong><_components.a href="/tooling/prometheus-api">{"Prometheus API access"}</_components.a>{":"}</_components.strong>{"\nInteract directly with Prometheus API endpoints for programmatic workflows."}</_components.li>{"\n"}</_components.ul></>;
}

export default MDXLayout